import Moment from 'moment-jalaali'
import { timeAgo } from '@persian-tools/persian-tools'
import { FixNumbers } from './convertType'
Moment.loadPersian({ usePersianDigits: true, dialect: 'persian-modern' })

export const GregorianToJalali = (gregorian, hasTime) => {
  gregorian = new Date(gregorian)
  gregorian = `${gregorian.getFullYear()}-${
    gregorian.getMonth() + 1
  }-${gregorian.getDate()} ${gregorian.getHours()}:${gregorian.getMinutes()}:${gregorian.getSeconds()}`
  return Moment(`${gregorian}`, 'YYYY-MM-DD HH:mm:ss').format(
    hasTime ? 'HH:mm:ss' : 'jYYYY/jMM/jDD'
  )
}

export const GregorianToJalali2 = (time) => {
  return Moment(time).format('jD jMMMM jYYYY')
}

export const TimeAgo = (date) => {
  return timeAgo(
    `${FixNumbers(GregorianToJalali(date).split('/')[0])}/${FixNumbers(
      GregorianToJalali(date).split('/')[1]
    )}/${FixNumbers(GregorianToJalali(date).split('/')[2])} ${FixNumbers(
      GregorianToJalali(date, true).split(':')[0]
    )}:${FixNumbers(GregorianToJalali(date, true).split(':')[1])}:${FixNumbers(
      GregorianToJalali(date, true).split(':')[2]
    )}`
  )
}
